import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "px-2 py-1 bg-green-500 text-white rounded-lg border h-fit"
}
const _hoisted_3 = {
  key: 1,
  class: "flex justify-between items-center w-full ml-3"
}
const _hoisted_4 = { class: "flex gap-2 items-center" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isMaterial && _ctx.data)
      ? (_openBlock(), _createElementBlock("header", {
          key: 0,
          id: "card-material",
          class: _normalizeClass([
      'flex justify-between gap-3 p-5 border-b cursor-pointer hover:opacity-75',
      _ctx.storeMaterial.currentMaterial?.id === _ctx.data.id ? 'bg-gray-50' : 'bg-white',
    ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.storeMaterial.selectMaterial(_ctx.index!)))
        }, [
          _createElementVNode("p", {
            class: "line-clamp-2 ml-8",
            title: _ctx.data.name
          }, _toDisplayString(_ctx.data.name), 9, _hoisted_1),
          (_ctx.data.done)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString("Concluído")))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isTrail && _ctx.data)
      ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, {
              name: "hi-solid-check-circle",
              class: _normalizeClass([_ctx.statusColor(), 'w-5 h-5'])
            }, null, 8, ["class"]),
            _createElementVNode("p", {
              class: "line-clamp-2",
              title: _ctx.data.name
            }, _toDisplayString(_ctx.data.name), 9, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("i", {
              class: _normalizeClass([
          _ctx.storeTrail.currentTrail === _ctx.data
            ? 'pi pi-angle-up'
            : 'pi pi-angle-down',
        ])
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}